/* eslint-disable no-redeclare */
import { deepCopy, setProperty } from "../../util/util"

const Patterns = {
    "Circular Grid": 11,
    "Covering Lines": 12,
    "Spiral" : 15,
    "No Pattern": 0,
    // "Rectangle": 1,
    // "Pendulum": 2,
    // "Slide": 3,
    // "Wave": 4,
    // "Diamond": 5,
    // "C-Clip": 6,
    // "Pendulum Left": 7,
    // "Pendulum Right": 8,
    // "Short Slide": 9,
    // "Zigzag": 13,
    // "Zigzag Horizontal": 14
}

export const DispenserTypeMap = {
    "BRUSH": 5,
    "PRESS_ROLLER": 8,
    "SCREW": 10,
    "TAPERED_SCREW": 11,
    "HYBRID_SCREW": 13,
    "POWDER": 15,
    "SEASONING": 16,
    "CONVEYOR": 20,
    "PUMP": 30,
    "PUMP_WITH_AGITATOR": 31,
    "SHUTTER": 45
};

export const DispenseType = {
    EQUATION_BASED_DISPENSING: 1,
    DISPENSE_WITH_FEEDBACK: 2,
}

export const DispensePatternType = {
    NO_PATTERN: 1,
    TO_AND_FRO: 2
}

export const ReverseDispensePatternType = {
    [DispensePatternType.NO_PATTERN]: "No Pattern",
    [DispensePatternType.TO_AND_FRO]: "To and Fro"
}

export const ReverseDispenseType = {
    [DispenseType.EQUATION_BASED_DISPENSING]: "Equation Based",
    [DispenseType.DISPENSE_WITH_FEEDBACK]: "Dispense with Feedback"
}
  
//TODO: Change the dropdown prop stucture so that this is not needed
const DispenserTypes = [
    { "value": DispenserTypeMap.SCREW, "head": "Screw" },
    { "value": DispenserTypeMap.CONVEYOR, "head": "Conveyor" },
    { "value": DispenserTypeMap.PRESS_ROLLER, "head": "Press Roller" },
    { "value": DispenserTypeMap.TAPERED_SCREW, "head": "Tapered Screw" },
    { "value": DispenserTypeMap.HYBRID_SCREW, "head": "Hybrid Screw" },
    { "value": DispenserTypeMap.BRUSH, "head": "Brush" },
    { "value": DispenserTypeMap.PUMP, "head": "Pump" },
    { "value": DispenserTypeMap.PUMP_WITH_AGITATOR, "head": "Pump with Agitator" },
    { "value": DispenserTypeMap.POWDER, "head": "Powder" },
    { "value": DispenserTypeMap.SEASONING, "head": "Seasoning" },
    { "value": DispenserTypeMap.SHUTTER, "head": "Shutter" }
];

const HeatingProfiles = [
    { "head": "No Heating", "value": "NO_HEATING" },
    { "head": "Mild Heating", "value": "MILD_HEATING" },
    { "head": "Full Heating", "value": "FULL_HEATING" }
];

const Allergens = {
    "GLUTEN" : 'GLUTEN',
    "DAIRY" : 'DAIRY',
    "NUTS" : 'NUTS',
    "SOY" : 'SOY',
    "PEANUT" : 'PEANUT',
    "TREENUT" : 'TREENUT',
    "MILK" : 'MILK',
    "FISH" : 'FISH',
    "SHELLFISH" : 'SHELLFISH',
};

// Define enums as constants first
const ContainerType = {
    LR: 'LR',
    MR: 'MR',
    SH: 'SH',
    TR: 'TR',
    TLR: 'TLR',
    TMR: 'TMR',
    TSH: 'TSH',
    TTR: 'TTR'
};

const BaseType = {
    SILVER: 'Silver',
    BLACK: 'Black'
};

const SpoutType = {
    DT: 'DT',
    TDT: 'TDT'
};

const containerTypes = [
    { head: ContainerType.LR, value: ContainerType.LR },
    { head: ContainerType.MR, value: ContainerType.MR },
    { head: ContainerType.SH, value: ContainerType.SH },
    { head: ContainerType.TR, value: ContainerType.TR },
    { head: ContainerType.TLR, value: ContainerType.TLR },
    { head: ContainerType.TMR, value: ContainerType.TMR },
    { head: ContainerType.TSH, value: ContainerType.TSH },
    { head: ContainerType.TTR, value: ContainerType.TTR }
];

// Base Types Array using enum values
const baseTypes = [
    { head: BaseType.SILVER, value: BaseType.SILVER },
    { head: BaseType.BLACK, value: BaseType.BLACK }
];

// Spout Types Array using enum values
const spoutTypes = [
    { head: SpoutType.DT, value: SpoutType.DT },
    { head: SpoutType.TDT, value: SpoutType.TDT }
];

export const dispenseTypes = [
    { value: DispenseType.EQUATION_BASED_DISPENSING, head: "Equation Based" },
    { value: DispenseType.DISPENSE_WITH_FEEDBACK, head: "Dispense with Feedback" },
];

export const dispensePatternTypes = [
    { value: DispensePatternType.NO_PATTERN, head: "No Pattern" },
    { value: DispensePatternType.TO_AND_FRO, head: "To and Fro" }
];



//Selected holds the data for rendering on every detail-oriented page
//ObjectToEdit holds the data to render on create and edit pages
//payload holds the payload to send

const InitialState = {
    dishes:[],
    dishId:"",
    selectedDish:{},
    ingredients:[],
    ingredientId:"",
    selectedIngredient:{},
    recipes:[],
    recipeId:"",
    selectedRecipe:{},
    payload :{},
    objectToEdit:{},
    editMode:false,
    DispenserTypes,
    HeatingProfiles,
    Allergens,
    Patterns,
    containerTypes,
    baseTypes,
    spoutTypes
}

export const cookBook = (state = InitialState, action) => {
    switch(action.type)
    {
        case 'GET_DISHES_DATA': 
                                return {
                                    ...state,
                                    dishes:action.data
                                }

        case 'GET_MORE_DISHES': 
                                return {
                                    ...state,
                                    dishes:[...state.dishes,...action.data]
                                }

        case 'SELECT_DISH': 
                                return {
                                    ...state,
                                    dishId:action.data
                                }

        case 'GET_DISH' : 
                                return {
                                    ...state,
                                    selectedDish:action.data
                                }

        case 'CLEAR_SELECT_DATA':
                                return {
                                    ...state,
                                    dishId:"",
                                    selectedDish:{},
                                    ingredientId:"",
                                    selectedIngredient:{},
                                    recipeId:"",
                                    selectedRecipe:{},
                                }

        case 'UPDATE_DISH_DATA':
                                var updatedValue = action.data.value;
                                var updatedColumn = action.data.column;
                                var dishData = JSON.parse(JSON.stringify(state.objectToEdit));
                                var payload = JSON.parse(JSON.stringify(state.payload));
                                dishData[updatedColumn]= updatedValue;
                                payload[updatedColumn] = updatedValue;
                                return {
                                    ...state,
                                    objectToEdit:{
                                        ...dishData
                                    },
                                    payload:{
                                        ...payload
                                    }
                                }

        case 'ADD_TAG':
                                 return {
                                    ...state,
                                    objectToEdit:{
                                        ...state.objectToEdit,
                                        tags:state.objectToEdit?.tags ? [...state.objectToEdit.tags,action.data.trim()] : [action.data.trim()]
                                     },
                                     payload:{
                                         ...state.payload,
                                         tags:state.objectToEdit?.tags ? [...state.objectToEdit.tags,action.data.trim()] : [action.data.trim()]
                                     }
                                 }
        case 'REMOVE_TAG':
                                 return {
                                       ...state,
                                       objectToEdit:{
                                        ...state.objectToEdit,
                                        tags:state.objectToEdit.tags.filter(item => item !== action.data)
                                       },
                                       payload:{
                                        ...state.payload,
                                        tags:state.payload.tags.filter(item => item !== action.data)
                                       }
                                }

        case 'ADD_IMAGE_PATH':
                                return {
                                    ...state,
                                    objectToEdit:{
                                        ...state.objectToEdit,
                                        imagePaths:state.objectToEdit?.imagePaths ? [...state.objectToEdit.imagePaths,action.data.trim()] : [action.data.trim()]
                                    },
                                    payload:{
                                        ...state.payload,
                                        imagePaths:state.objectToEdit?.imagePaths ? [...state.objectToEdit.imagePaths,action.data.trim()] : [action.data.trim()]
                                       }
                                }

        case 'REMOVE_IMAGE_PATH':
                                return {
                                        ...state,
                                        objectToEdit:{
                                        ...state.objectToEdit,
                                        imagePaths:state.objectToEdit.imagePaths.filter(item => item !== action.data)
                                    },
                                    payload:{
                                        ...state.payload,
                                        imagePaths: state.payload.imagePaths.filter(item => item !== action.data)
                                       }
                                }
    
        case 'GET_RECIPES_DATA': 
                                return {
                                    ...state,
                                    recipes:action.data
                                }

        case 'GET_MORE_RECIPES_DATA': 
                                return {
                                    ...state,
                                    recipes:[...state.recipes,...action.data]
                                }

        case 'SELECT_RECIPE' : 
                                return {
                                    ...state,
                                    recipeId:action.data
                                }

        case 'GET_RECIPE': 
                                return {
                                    ...state,
                                    selectedRecipe:action.data
                                }
        
        case 'UPDATE_RECIPE_DATA':
                                    var recipeData = JSON.parse(JSON.stringify(state.objectToEdit));
                                    var payload = JSON.parse(JSON.stringify(state.payload));
                                    recipeData[action.data.column]= action.data.value;
                                    payload[action.data.column] = action.data.value;
                                    return {
                                        ...state,
                                        objectToEdit:{
                                            ...recipeData
                                        },
                                        payload:{
                                            ...payload
                                        }
                                    }

        case 'GET_INGREDIENTS_DATA':
                                return {
                                    ...state,
                                    ingredients:action.data
                                }

        case 'GET_MORE_INGREDIENTS_DATA':
                                    return {
                                        ...state,
                                        ingredients:[...state.ingredients,...action.data]
                                    }

        case 'SELECT_INGREDIENT':
                                 return {
                                    ...state,
                                    ingredientId:action.data
                                 }

        case 'GET_INGREDIENT' : 
                                 return {
                                     ...state,
                                     selectedIngredient:action.data
                                 }
        
        case 'UPDATE_INGREDIENT_DATA':
                                    var newData = deepCopy(state.objectToEdit),
                                        editedPayload = deepCopy(state.payload),
                                        updatedValue = setProperty(newData, action.data.value, action.data.column);

                                    editedPayload = setProperty(editedPayload, action.data.value, action.data.column);
                                    
                                 return {
                                    ...state,
                                    objectToEdit: updatedValue,
                                    payload: editedPayload
                                 }

        case 'SET_INITIAL_OBJECT_EDIT':
                                return {
                                   ...state,
                                   objectToEdit:action.data
                                }

        case 'SET_INITIAL_PAYLOAD': 
                                return {
                                ...state,
                                payload:action.data
                                }

        case 'UPDATE_PAYLOAD': 
                               var payload = {...state.payload};
                               setProperty(payload,action.data.head,action.data.column)
                               return {
                                ...state,
                                payload:{...payload}
                            }
                               
        case 'CHANGE_EDIT_MODE':
                                 return {
                                    ...state,
                                    editMode:action.data.editMode,
                                    objectToEdit:JSON.parse(JSON.stringify(action.data.objectToEdit)),
                                    payload:{}
                                 }
                                  
        default:
                return state
    }
}

export default cookBook